import type React from 'react'

import { cn } from '../lib/utils'

export interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode
}

export const Flex = ({ className, children, ...props }: FlexProps) => {
    return (
        <div className={cn('flex', className)} {...props}>
            {children}
        </div>
    )
}
